import React from "react";
import type { FunctionComponent } from "react";
import { useColorModeValue, MenuItem, Icon, Stack, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";

interface Props {
  menuLabel: string;
  className?: string;
  isDisabled?: boolean;
  onClick?: (event: { stopPropagation: () => void }) => void;
  icon?: IconType;
  iconSize?: string;
}

export const OptionsMenuItem: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
  menuLabel,
  className,
  onClick,
  isDisabled,
  icon,
  iconSize = "1.1rem",
}) => {
  const fontColor = useColorModeValue("gray.500", "gray.400");

  return (
    <MenuItem
      _hover={{ color: "primary.default" }}
      className={className}
      isDisabled={isDisabled}
      fontSize={"sm"}
      color={fontColor}
      onClick={(event) => {
        event.stopPropagation();
        onClick && onClick(event);
      }}>
      <Stack direction="row" spacing={2} alignItems="center">
        {icon && <Icon as={icon} fontSize={iconSize} />}
        <Text>{menuLabel}</Text>
      </Stack>
    </MenuItem>
  );
};
